import { useEffect, useRef } from 'react';
import { useHandlePhotoLike } from 'dibs-interiors-photos/exports/useHandlePhotoLike.ts';

function hasAutosaveParam(): boolean {
    const params = new URLSearchParams(window.location.search);
    return params.get('save') === 'photo';
}

type AutosavePayload = {
    photoId: string;
    photoLikeId: string;
    photoNodeId: string;
    hasFetchedPhotoLikes: boolean;
};

export function useAutosavePhoto({
    photoId,
    photoLikeId,
    photoNodeId,
    hasFetchedPhotoLikes,
}: AutosavePayload): void {
    const { handlePhotoLike } = useHandlePhotoLike({
        photoId,
        photoLikeId,
        photoNodeId,
    });

    const hasTriedAutosavePhotoRef = useRef(false);

    useEffect(() => {
        if (hasFetchedPhotoLikes && hasAutosaveParam() && !hasTriedAutosavePhotoRef.current) {
            hasTriedAutosavePhotoRef.current = true;
            if (!photoLikeId) {
                handlePhotoLike();
            }
        }
    }, [hasFetchedPhotoLikes, photoLikeId, handlePhotoLike]);
}
